import { cn } from "@/lib/utils";

/**
 * Editorial section divider — a hairline rule broken in the middle by the
 * 3-bar logo mark (sage top bar, ink lower bars). Acts as a recurring brand
 * device between major homepage sections.
 */
export function SectionMark({ className }: { className?: string }) {
  return (
    <div
      role="presentation"
      aria-hidden="true"
      className={cn(
        "mx-auto flex w-full max-w-6xl items-center gap-5 px-6",
        className,
      )}
    >
      <span className="h-px flex-1 bg-border" />
      <span className="flex flex-col gap-[3px]">
        <span className="block h-[3px] w-5 bg-primary" />
        <span className="block h-[3px] w-3.5 bg-foreground" />
        <span className="block h-[3px] w-2 bg-foreground" />
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
